<div class="container mx-auto">
  <div class="mt-8">
    <h1 class="font-['Apex_Rounded_Medium'] lg:text-3xl text-xl">{{ "userAdministration.title" | translate }}</h1>
  </div>

  <div class="mt-8">
    <p-panel [showHeader]="false">
      <p-table #userTable [value]="isLoading() ? [] : users()" [showLoader]="false" [paginator]="true"
        [rows]="itemsPerPage" [first]="rs2Query.skip ?? 0" [rowsPerPageOptions]="[5, 10, 20]"
        [currentPageReportTemplate]="'primeng.currentPageReportTemplate' | translate" [showCurrentPageReport]="true"
        [loading]="isLoading()" dataKey="key" [scrollable]="true" [lazy]="true" [totalRecords]="totalRecords"
        [sortField]="getUserTableSortField()" [sortOrder]="rs2Query.sortExpression?.order ?? -1"
        (onPage)="pageChange($event)" (onSort)="onSort($event)"
        [resizableColumns]="true" columnResizeMode="expand" gateTableStateKey="userDirectoryTableState">

        <ng-template #caption>
          <div class="grid lg:grid-cols-2 sm:grid-cols-3 grid-cols-1 md:text-base text-sm">
            <div class="col-span-1 my-auto md:mx-0 mb-3">
              <p class="font-['Apex_Rounded_Medium'] text-sm">
                {{ "userAdministration.tableTitle" | translate }}
              </p>
            </div>
            @if (!(isLoading() && users().length === 0)) {
              <div class="lg:col-span-1 sm:col-span-2 col-span-1 sm:text-right text-center">
                <div class="grid gap-4 grid-cols-1 sm:grid-cols-2">
                  @if (searchFilter()) {
                    <div class="col-span-1">
                      <p-button [label]="'clearSearch' | translate" severity="danger" icon="pi pi-filter-slash"
                        (onClick)="clearDataTable(userTable)" styleClass="md:w-auto w-full md:text-base text-sm" />
                    </div>
                  }
                  <div class="col-span-1 sm:col-start-2">
                    <p-inputgroup>
                      <input pInputText [placeholder]="'userAdministration.searchPlaceholder' | translate"
                        [ngModel]="searchFilter()" (ngModelChange)="onSearchFilterChange($event)"
                        />
                      <button type="button" icon="pi pi-search" [loading]="isLoading()" pButton
                        (click)="searchUser()" [disabled]="!searchFilter() || searchFilter().trim().length < 3"></button>
                    </p-inputgroup>
                  </div>
                </div>
              </div>
            } @else {
              <div class="lg:col-span-1 sm:col-span-2 col-span-1 sm:text-right text-center">
                <div class="grid gap-4 grid-cols-1 sm:grid-cols-2">
                  <div class="col-span-1">
                    <p-skeleton width="100%" height="2.5rem"></p-skeleton>
                  </div>
                  <div class="col-span-1">
                    <p-skeleton width="100%" height="2.5rem"></p-skeleton>
                  </div>
                </div>
              </div>
            }
          </div>
        </ng-template>

        <ng-template #header>
          <tr>
            <th pResizableColumn pSortableColumn="firstName">
              {{ "userAdministration.name" | translate }}
              <p-sortIcon field="firstName" />
            </th>
            <th pResizableColumn pSortableColumn="email">
              {{ "userAdministration.email" | translate }}
              <p-sortIcon field="email" />
            </th>
            <th pResizableColumn pFrozenColumn alignFrozen="right" class="w-[10%]"></th>
          </tr>
        </ng-template>

        <ng-template #body let-user>
          <tr>
            <td>
              <span class="p-column-title">{{ "userAdministration.name" | translate }}</span>
              <span class="table-col-primary">
                {{ ((user.salutation ?? "" | salutation) | translate) + " " + (user.firstName ?? "") + " " + (user.lastName ?? "") }}
              </span>
            </td>
            <td>
              <span class="p-column-title">{{ "userAdministration.email" | translate }}</span>
              <gate-email-status [email]="user.email" [emailVerified]="user.emailVerified"></gate-email-status>
            </td>
            <td class="action-td" pFrozenColumn alignFrozen="right">
              <p-button size="small" styleClass="btn-impersonate !h-[28px] w-full" (onClick)="openUser(user)">
                {{ "openButton" | translate }}
              </p-button>
            </td>
          </tr>
        </ng-template>

        <ng-template #loadingbody>
          @for (i of [1,2,3,4,5]; track i) {
            <tr>
              <td>
                <span class="p-column-title">
                  <p-skeleton width="4rem" height="1rem"></p-skeleton>
                </span>
                <div class="w-[30%] lg:w-full">
                  <p-skeleton class="h-[1rem] mt-1"></p-skeleton>
                </div>
              </td>
              <td>
                <span class="p-column-title">
                  <p-skeleton width="4rem" height="1rem"></p-skeleton>
                </span>
                <div class="w-[30%] lg:w-full">
                  <p-skeleton class="h-[1rem] mt-1"></p-skeleton>
                </div>
              </td>
              <td class="action-td" pFrozenColumn alignFrozen="right">
                <div class="flex justify-end">
                  <p-skeleton width="5rem" height="1.5rem"></p-skeleton>
                </div>
              </td>
            </tr>
          }
        </ng-template>

        <ng-template #emptymessage>
          <tr class="emptymessage">
            <td colspan="3" class="text-center">
              {{ "userAdministration.noRecordsFound" | translate }}
            </td>
          </tr>
        </ng-template>
      </p-table>
    </p-panel>
  </div>
</div>
